import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ManageVacationsSharedModule } from '@app/activo2/manage-vacations/components/manage-vacations-shared.module';
import { ComponentsModule } from '@app/components/components.module';
import { StepperModule } from '@app/components/stepper/stepper.module';
import { TranslateModule } from '@ngx-translate/core';

import { MomoVacationsStepperModule } from './components/vacations-stepper.module';
import { MomoManageVacationsPage } from './manage-vacations.page';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ComponentsModule,
    StepperModule,
    MomoVacationsStepperModule,
    ManageVacationsSharedModule
  ],
  exports: [MomoManageVacationsPage],
  declarations: [MomoManageVacationsPage]
})
export class MomoManageVacationsModule {}
